import { getClub, getCurrentHostUrl } from "@/utils/getClub";
import { sessionOptions } from "@/utils/getSession";
import { redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { useSession } from "@tanstack/react-start/server";
import * as Sentry from "@sentry/node";

export const logout = createServerFn({ method: "POST" }).handler(async () => {
	try {
		const host = await getCurrentHostUrl();
		// biome-ignore lint/correctness/useHookAtTopLevel: this is not a hook
		const session = await useSession(sessionOptions);
		const club = await getClub({ data: { host: host! } });

		await session?.clear();

		if (club?.visibility === "PRIVATE") {
			throw redirect({
				to: "/login",
			});
		}

		return session?.data;
	} catch (err) {
		Sentry.captureException(err);

		throw err;
	}
});
